import React from "react";

import { normaliseResponsiveProp } from "../../../utils/responsiveProps";
import Box from "../Box";
import { ColumnsContext } from "./ColumnsContext";
import { CollapsibleProps, resolveCollapsibleProps } from "./utils";

import type {
  ResponsiveDimension,
  AlignItems,
  ResponsiveProp,
  JustifyContent
} from "../../../types";

type Props = CollapsibleProps & {
  children: React.ReactNodeArray;
  space?: ResponsiveDimension;
  alignY?: ResponsiveProp<AlignItems>;
  alignX?: ResponsiveProp<JustifyContent>;
};

export default function Columns({
  children,
  collapseBelow,
  reverseOnCollapse,
  alignY,
  alignX,
  space = "none"
}: Props) {
  const {
    flexDirection,
    collapseOnMobile,
    collapseOnTablet
  } = resolveCollapsibleProps({
    collapseBelow,
    reverseOnCollapse
  });

  const [mobileSpace, tabletSpace, desktopSpace] = normaliseResponsiveProp(
    space
  );

  return (
    <Box
      display="flex"
      flexDirection={flexDirection}
      alignItems={alignY}
      justifyContent={alignX}
      width="100%"
    >
      <ColumnsContext.Provider
        value={{
          collapseOnMobile,
          collapseOnTablet,
          mobileSpace,
          tabletSpace,
          desktopSpace,
          reverseOnCollapse
        }}
      >
        {children}
      </ColumnsContext.Provider>
    </Box>
  );
}
